import { useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import type { SupportedLanguage } from './languages';

const STORAGE_KEY = 'admin-language';

export const useI18n = () => {
  const { t, i18n } = useTranslation();

  const changeLanguage = useCallback(
    (language: SupportedLanguage) => {
      try {
        localStorage.setItem(STORAGE_KEY, language);
        void i18n.changeLanguage(language);
      } catch (error) {
        console.warn('Could not save language preference:', error);
        // Still change the language even if storage fails
        void i18n.changeLanguage(language);
      }
    },
    [i18n],
  );

  const getCurrentLanguage = useCallback((): SupportedLanguage => {
    return i18n.language as SupportedLanguage;
  }, [i18n.language]);

  const currentLanguage = useMemo(() => i18n.language as SupportedLanguage, [i18n.language]);

  return useMemo(
    () => ({
      t,
      changeLanguage,
      getCurrentLanguage,
      currentLanguage,
    }),
    [t, changeLanguage, getCurrentLanguage, currentLanguage],
  );
};
